import React from 'react';
import styled, { keyframes } from 'styled-components';

const GOLD = 'var(--brand-gold)';
const DARK = 'var(--brand-black)';

const PanelContainer = styled.div`
  flex: 1;
  background: white;
  border-left: 1px solid #eaeaea;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: -10px 0 40px rgba(0,0,0,0.02);
`;

const HeaderBar = styled.div`
  height: 64px;
  background: #f7f7f7;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-family: monospace;
  font-size: 14px;
  color: #666;
`;

const ContentWrap = styled.div`
  flex: 1;
  padding: 40px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const BasicPanel: React.FC<{ title: string, subtitle?: string, children?: React.ReactNode }> = ({ title, subtitle, children }) => (
  <PanelContainer>
    <HeaderBar>prest0n-agent / {title.toLowerCase().replace(/\s+/g, '-')}</HeaderBar>
    <ContentWrap style={{ animation: `${slideUp} 0.5s ease-out forwards` }}>
      <h1 style={{ fontSize: '48px', color: DARK, marginBottom: '16px' }}>{title}</h1>
      {subtitle && <p style={{ fontSize: '24px', color: '#666', marginBottom: '40px' }}>{subtitle}</p>}
      {children}
    </ContentWrap>
  </PanelContainer>
);

// We'll export individual ones
export const BrowserUsePanel = () => {
    return (
        <PanelContainer>
            <HeaderBar>Agent Browser · session_9f2a</HeaderBar>
            <ContentWrap style={{ background: '#f0f2f5', position: 'relative' }}>
                <div style={{
                    width: '900px', height: '600px', background: 'white', borderRadius: '12px',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)', overflow: 'hidden',
                    display: 'flex', flexDirection: 'column'
                }}>
                    <div style={{ height: '40px', background: '#e0e0e0', display: 'flex', alignItems: 'center', padding: '0 16px', gap: '8px' }}>
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#ff5f56' }}/>
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#ffbd2e' }}/>
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#27c93f' }}/>
                        <div style={{ flex: 1, background: 'white', marginLeft: '16px', borderRadius: '4px', height: '24px', fontSize: '12px', lineHeight: '24px', padding: '0 8px', color: '#666' }}>https://my.uscis.gov/</div>
                    </div>
                    <div style={{ flex: 1, padding: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <h2 style={{ fontSize: '32px', marginBottom: '24px' }}>myUSCIS Sign In</h2>
                        <div style={{ width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div style={{ height: '48px', border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9', display: 'flex', alignItems: 'center', padding: '0 12px' }}>fernandohidalgoesq@yahoo.com</div>
                            <div style={{ height: '48px', border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9', display: 'flex', alignItems: 'center', padding: '0 12px' }}>••••••••••••</div>
                            <div style={{ height: '48px', background: '#3b82f6', borderRadius: '4px', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>Sign In</div>
                        </div>
                    </div>
                </div>

                {/* Animated Captcha pop over */}
                <div style={{
                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(4px)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    animation: `${slideUp} 0.5s ease-out 6s both`
                }}>
                    <div style={{ width: '400px', background: 'white', border: '1px solid #ccc', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
                        <div style={{ background: '#4A90E2', color: 'white', padding: '20px' }}>
                            <div style={{ fontSize: '18px' }}>Select all images with</div>
                            <div style={{ fontSize: '28px', fontWeight: 'bold' }}>traffic lights</div>
                        </div>
                        <div style={{ padding: '8px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                            {Array.from({length: 9}).map((_, i) => (
                                <div key={i} style={{ aspectRatio: '1/1', background: '#eee', position: 'relative' }}>
                                    {[0, 2, 3, 6, 7].includes(i) && (
                                        <div style={{ position: 'absolute', inset: 0, border: `4px solid ${GOLD}`, background: `${GOLD}44`, display: 'flex', alignItems: 'center', justifyContent: 'center', animation: `fadeIn 0.3s forwards ${8 + i*0.2}s`, opacity: 0 }}>
                                            <span style={{color: 'white', fontSize: '32px', textShadow: '0 2px 4px rgba(0,0,0,0.5)'}}>✓</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div style={{ padding: '16px', display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #eee' }}>
                            <div style={{ background: '#4A90E2', color: 'white', padding: '8px 24px', fontWeight: 'bold', borderRadius: '2px' }}>Verify</div>
                        </div>
                    </div>
                </div>
            </ContentWrap>
        </PanelContainer>
    );
};

export const DeepResearchPanel = () => <BasicPanel title="Deep Research Engine" subtitle="Synthesizing multi-source legal doctrine" />;
export const DocumentReaderPanel = () => <BasicPanel title="Document Reader" subtitle="Processing 20+ file formats with high accuracy" />;
export const LegalDraftPanel = () => <BasicPanel title="Legal Drafter" subtitle="Generating formatted attorney-review ready drafts" />;
export const BilingualPanel = () => <BasicPanel title="Bilingual Flip" subtitle="Instant context preservation across ES / EN" />;
export const VoicePanel = () => <BasicPanel title="Voice Interface" subtitle="Natural conversation with real-time TTS rendering" />;
export const AgentPanel = () => <BasicPanel title="Agent Builder" subtitle="Create specialized workflow agents" />;
export const MemoryPanel = () => <BasicPanel title="Memory Recall" subtitle="Long-term state tracking for contextually-aware logic" />;
export const MarketingPanel = () => <BasicPanel title="Marketing Campaign" subtitle="Automated multi-channel outbound execution" />;
